var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getAllVerificationCountries, getCurrentKYCStatus, getVerificationToken, } from '../../../Services/methods/verifications';
import { storage } from '../../../Services/storage';
export var DOCS_SUB_TYPES = ['FRONT_SIDE', 'BACK_SIDE'];
export var Screens;
(function (Screens) {
    Screens[Screens["SET_DOCUMENTS"] = 0] = "SET_DOCUMENTS";
    Screens[Screens["LOAD_DOCUMENTS"] = 1] = "LOAD_DOCUMENTS";
    Screens[Screens["SUM_SUB"] = 2] = "SUM_SUB";
})(Screens || (Screens = {}));
export var StepByStatus = {
    yes: Screens.SUM_SUB,
    no: Screens.SET_DOCUMENTS,
    partial: Screens.LOAD_DOCUMENTS,
};
export var getKYCInfo = function () {
    return Promise.all([getCurrentKYCStatus(), getAllVerificationCountries()])
        .then(function (_a) {
        var _b;
        var status = _a[0], countries = _a[1];
        var identityDocsSet = status.requiredIdDocs.docSets.find(function (item) { return item.idDocSetType === 'IDENTITY'; });
        var identityStepExist = Boolean(identityDocsSet);
        var docTypes = (identityDocsSet === null || identityDocsSet === void 0 ? void 0 : identityDocsSet.types) || [];
        var submittedDocsInformation = (_b = status.submittedDocs) === null || _b === void 0 ? void 0 : _b.IDENTITY;
        // Uploaded documents ids
        var submittedDocsIds = (submittedDocsInformation === null || submittedDocsInformation === void 0 ? void 0 : submittedDocsInformation.imageIds) || [];
        // Current DocType
        var currentDocType = submittedDocsInformation === null || submittedDocsInformation === void 0 ? void 0 : submittedDocsInformation.idDocType;
        // Current country
        var currentCountry = getCurrentCountry(countries, submittedDocsInformation === null || submittedDocsInformation === void 0 ? void 0 : submittedDocsInformation.country);
        // Image result map
        var imageReviewClientResult = getFileReviewMap(submittedDocsInformation === null || submittedDocsInformation === void 0 ? void 0 : submittedDocsInformation.imageReviewResults);
        // Current document review status
        var isDocumentAlreadyUploaded = getDocumentsLoadingStatus(submittedDocsInformation === null || submittedDocsInformation === void 0 ? void 0 : submittedDocsInformation.idDocType, submittedDocsIds, imageReviewClientResult);
        var currentScreen = identityStepExist
            ? StepByStatus[isDocumentAlreadyUploaded]
            : Screens.SUM_SUB;
        return {
            countries: countries,
            docTypes: docTypes,
            token: undefined,
            currentCountry: currentCountry,
            currentDocType: currentDocType,
            identityStepExist: identityStepExist,
            imageReviewClientResult: imageReviewClientResult,
            currentScreen: currentScreen,
            submittedDocsIds: submittedDocsIds.length
                ? submittedDocsIds
                : undefined,
        };
    })
        .then(function (res) {
        var _a;
        if ((_a = res.currentCountry) === null || _a === void 0 ? void 0 : _a.code) {
            return getVerificationToken(res.currentCountry.code)
                .then(function (tokenInfo) {
                return __assign(__assign({}, res), { token: tokenInfo.token });
            })
                .catch(function () { return res; });
        }
        return res;
    });
};
function getFileReviewMap(reviewResult) {
    if (reviewResult === void 0) { reviewResult = {}; }
    var fileReviewMap = new Map();
    Object.keys(reviewResult).map(function (fileId) {
        var fileReview = reviewResult[fileId];
        fileReviewMap.set(fileId, fileReview === null || fileReview === void 0 ? void 0 : fileReview.clientComment);
    });
    return fileReviewMap;
}
export function getActualFilesIds(filesIds, docType) {
    return filesIds.slice(0, getDocSubTypesByDocType(docType).length);
}
export function getDocSubTypesByDocType(docType) {
    switch (docType) {
        case 'PASSPORT':
            return ['FRONT_SIDE'];
        default:
            return ['FRONT_SIDE', 'BACK_SIDE'];
    }
}
function getDocumentsLoadingStatus(currentDocType, submittedDocsIds, fileReviewResult) {
    if (!currentDocType) {
        return 'no';
    }
    var actualFilesIds = submittedDocsIds.slice(0, getDocSubTypesByDocType(currentDocType).length);
    var currentDocTypeIdsReview = actualFilesIds.map(function (fileId) {
        if (!fileId) {
            return;
        }
        return fileReviewResult === null || fileReviewResult === void 0 ? void 0 : fileReviewResult.get(fileId);
    });
    if (actualFilesIds.includes(undefined) ||
        currentDocTypeIdsReview.find(function (item) { return typeof item === 'string'; })) {
        return 'partial';
    }
    return 'yes';
}
function getCurrentCountry(countryList, currentCountryCode) {
    var defaultCountry = countryList[0];
    if (!currentCountryCode) {
        return undefined;
    }
    return (countryList.find(function (item) { return item.code === currentCountryCode; }) ||
        defaultCountry);
}
var DocTypeLabelMap = new Map()
    .set('PASSPORT', 'Passport')
    .set('ID_CARD', 'Id card')
    .set('RESIDENCE_PERMIT', 'Residence permit')
    .set('DRIVERS', "Driver's license");
export var docTypeToView = function (docType) {
    return DocTypeLabelMap.get(docType) || docType;
};
export var setKYCSubmittedWithCurrentOrder = function () {
    var orderId = storage.ORDER_ID.get();
    localStorage.setItem('KYC_SUBMITTED_IN_ORDER', orderId);
};
export var isKYCSubmittedWithCurrentOrder = function () {
    return (storage.ORDER_ID.get() === localStorage.getItem('KYC_SUBMITTED_IN_ORDER'));
};
export var clearSubmittedKYCOrderId = function () {
    localStorage.removeItem('KYC_SUBMITTED_IN_ORDER');
};
